import { Component, Renderer2 } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "app-delivery-type-cell-renderer",
  templateUrl: "./delivery-type-cell-renderer.component.html",
  styleUrls: ["./delivery-type-cell-renderer.component.css"],
})
export class DeliveryTypeCellRendererComponent
  implements ICellRendererAngularComp
{
  deliveryTypes = [
    { value: "INTERNAL_DELIVERY", viewValue: "INTERNAL_DELIVERY" },
    { value: "EXTERNAL_DELIVERY", viewValue: "EXTERNAL_DELIVERY" },
    { value: "PICKUP", viewValue: "PICKUP" },
  ];

  params: ICellRendererParams;
  deliveryType: any;

  constructor(private renderer: Renderer2) {}

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.deliveryType = this.params.value;
  }

  getValue(): any {
    return this.deliveryType;
  }

  isPopup(): boolean {
    return true;
  }

  onSelectionChange() {
    this.params.api.stopEditing(); // Stop editing the cell before updating the value
    this.params.setValue(this.deliveryType); // Update the cell value within AG Grid
  }

  // Optional: If you need to focus the cell after the editing is complete
  agAfterViewInit(): void {
    const selectElement = document.querySelector("mat-select");
    if (selectElement) {
      this.renderer.selectRootElement(selectElement).focus();
    }
  }
}